import './index.css'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppProviders } from '@/main/providers/app-providers'
import { router } from '@/main/routes'
import { ErrorBoundary } from '@/shared/ui/components/error-boundary'
import {
  emitColdStartPresence,
  registerTelemetryPageHideFlush,
  startPresenceTracking,
  startScreenViewTracking,
  startTelemetryFlushTimer,
} from '@/shared/infra/telemetry'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { makeSupabaseClient } from '@/shared/infra/supabase'
import { env } from '@/main/config'

function removeLegacyHunterModeFlag(): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem('cc-hunter-mode')
  } catch {
    return
  }
}

removeLegacyHunterModeFlag()

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </ErrorBoundary>,
)

const telemetryHttpClient = makeSupabaseEdgeHttpClient()
emitColdStartPresence(telemetryHttpClient)
startPresenceTracking(telemetryHttpClient)
startScreenViewTracking(router, telemetryHttpClient)
startTelemetryFlushTimer()
registerTelemetryPageHideFlush({
  getAuthToken: async () =>
    (await makeSupabaseClient().auth.getSession()).data.session?.access_token ?? null,
  baseUrl: env.edgeFunctionsBaseUrl,
})

const deferInitSentry = (): void => {
  void import('@/main/sentry/init-sentry').then(({ initSentry }) => initSentry())
}
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
  window.requestIdleCallback(deferInitSentry)
} else {
  setTimeout(deferInitSentry, 0)
}
